// extracted by mini-css-extract-plugin
export var cardIcon = "_96-5";
export var cardIconUnframed = "_96-9";
export var checkboxCard = "_96-0";
export var checkboxCardSelected = "_96-4";
export var disabled = "_96-2";
export var interactive = "_96-1";
export var outerBorder = "_96-3";
export var spacerMedium = "_96-8";
export var spacerSmall = "_96-7";
export var spacerXsmall = "_96-6";